import styled, { css } from 'styled-components';

const Title = styled.label`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular}
  color: ${props => props.theme.colors.textPrimary};
  line-height: 18px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  ${props =>
    !props.available &&
    css`
      color: ${props.theme.colors.textHint};
      text-decoration: line-through;
    `}
`;

export default Title;
